import { ProviderName } from '../account/models/login-response.model';

export interface Video {
  VideoId: number;
  ProviderId: VideoProvider;
  VideoKey: string;
  VideoKey2: string;
  ThumbNail: string;
}

/**
 * A list of video providers we support
 */
export enum VideoProvider {
  YouTube = ProviderName.YouTube,
  Vimeo = ProviderName.Viemo,
  Boxcast = ProviderName.Boxcast,
  Streamable = ProviderName.Streamable,
  Twitch = ProviderName.Twitch,
  StreamAMG = ProviderName.StreamAMG,
}
